<template>
  <donut-modal-sections-title
    title="Add a goal for this onboarding Journey"
  />
  <donut-input-text
    v-model="goalText"
    placeholder="What do you want to accomplish?"
    :autofocus="true"
    @enter="addGoal"
  />
  <donut-modal-sections-actions
    button-text="Add goal"
    :is-save-disabled="!goalText"
    @save="addGoal"
  />
</template>

<script setup>
  import { ref } from 'vue';
  import { useStore } from 'vuex';

  const { commit, state } = useStore();
  const goalText = ref(null);

  const addGoal = () => {
    if (!goalText.value) return;

    // `goals` here is the same array object as in `goals.vue`, which lets me avoid using vuex state unnecessarily.
    state.modal.data.goals.push({ text: goalText.value, selected: true });
    commit('closeModal');
  };
</script>
